import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { getAdminListings } from '../api';

const AdminDashboard = () => {
  const [count, setCount] = useState({ total: 0, rent: 0, property: 0, published: 0 });

  useEffect(() => {
    const load = async () => {
      try {
        const { listings } = await getAdminListings({ limit: 1000 });
        setCount({
          total: listings.length,
          rent: listings.filter((item) => item.listingType === 'rent').length,
          property: listings.filter((item) => item.listingType === 'property').length,
          published: listings.filter((item) => item.status === 'published').length,
        });
      } catch (_error) {
        // dashboard stays usable even if stats fail
      }
    };

    load();
  }, []);

  const cards = [
    { label: 'Total listings', value: count.total },
    { label: 'Rent / Lease', value: count.rent },
    { label: 'Property Listing', value: count.property },
    { label: 'Published', value: count.published },
  ];

  return (
    <div className="space-y-[1.25rem] px-[1.25rem] py-[1.25rem]">
      <div className="rounded-[18px] border border-[#262626] bg-[#111] p-[1.25rem]">
        <p className="text-[12px] font-semibold uppercase tracking-[0.18em] text-[#EEC24B]">Overview</p>
        <h2 className="mt-[0.35rem] text-[28px] font-bold text-white">Admin dashboard</h2>
        <p className="mt-[0.35rem] max-w-[720px] text-[15px] text-[#BDBDBD]">
          Manage all rental and property listing content from a dedicated admin layout.
        </p>
      </div>

      <div className="grid gap-[1rem] md:grid-cols-2 xl:grid-cols-4">
        {cards.map((card) => (
          <div key={card.label} className="rounded-[18px] border border-[#262626] bg-[#111] p-[1.1rem]">
            <p className="text-[13px] uppercase tracking-[0.14em] text-[#999]">{card.label}</p>
            <p className="mt-[0.4rem] text-[34px] font-bold text-white">{card.value}</p>
          </div>
        ))}
      </div>

      <div className="grid gap-[1rem] lg:grid-cols-3">
        <Link to="/admin/create" className="rounded-[18px] border border-[#262626] bg-[#111] p-[1.2rem] hover:border-[#EEC24B]">
          <p className="text-[13px] font-semibold uppercase tracking-[0.16em] text-[#EEC24B]">Create</p>
          <h3 className="mt-[0.4rem] text-[22px] font-bold text-white">Create listing</h3>
        </Link>
        <Link to="/admin/rent" className="rounded-[18px] border border-[#262626] bg-[#111] p-[1.2rem] hover:border-[#EEC24B]">
          <p className="text-[13px] font-semibold uppercase tracking-[0.16em] text-[#EEC24B]">Rent</p>
          <h3 className="mt-[0.4rem] text-[22px] font-bold text-white">Rent / Lease listings</h3>
        </Link>
        <Link to="/admin/property-listing" className="rounded-[18px] border border-[#262626] bg-[#111] p-[1.2rem] hover:border-[#EEC24B]">
          <p className="text-[13px] font-semibold uppercase tracking-[0.16em] text-[#EEC24B]">Property</p>
          <h3 className="mt-[0.4rem] text-[22px] font-bold text-white">Property listing entries</h3>
        </Link>
      </div>
    </div>
  );
};

export default AdminDashboard;
